import React from 'react';
import { Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { MealCard } from '../MealCard';

import type { MealsComponentProps } from './MealsComponent.types';

import 'swiper/css';
import 'swiper/css/scrollbar';
import styles from './MealsComponent.module.css';

export const MealsComponent: React.FC<MealsComponentProps> = ({ data }) => {
    return (
        <div className={styles.mealsComponent}>
            <Swiper
                className={styles.mealsCarousel}
                modules={[Scrollbar]}
                slidesPerView={'auto'}
                slidesOffsetAfter={16}
                slidesOffsetBefore={16}
                spaceBetween={16}
                scrollbar={{ draggable: true }}
                onSlideChange={() => console.log('slide change')}
            >
                {data.map((meal) => (
                    <SwiperSlide key={meal.id} className={styles.mealItem}>
                        <MealCard data={meal} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};